<template>
  <div class="row">
    <div class="col-12"
         :class="{'col-md-9' : address_missingNo }">
      <div class="rueden-input">
        <label class="bold-600">
          {{ addressLabel }}
          <span v-if="required" class="required-input" :class="{'error-input' : $v.address_google.$error}">* </span>
          <a v-if="tooltip" v-tooltip="{content: tooltip, trigger: 'click' }">
            <i class="fa fa-question-circle-o"></i>
          </a>
        </label>
        <vue-google-autocomplete
            id="address_google"
            ref="addressGoogle"
            classname="form-control"
            placeholder=""
            types="address"
            v-on:placechanged="getAddressData"
            v-on:blur="blurGetAddressData"
            :country="countries"
            v-model="address_google"
            :required="required"
            :class="{'border-danger' : $v.address_google.$error}"
        >
        </vue-google-autocomplete>
        <input class="form-control d-none" type="text" v-model="data.strasse" name="strasse" :required="required"/>
        <template v-if="$v.address_google.$error || $v.strasse_nummer.$error">
          <!-- <small class="" v-if="$v.address_google.required === false">Pflichtangabe</small> -->
          <small class="" v-if="$v.strasse_nummer.required === false">Geben Sie bitte eine Hausnummer ein.</small>
          <small class="" v-else-if="$v.strasse_nummer.startsWithDigit === false">Geben Sie bitte eine gültige Hausnummer ein.</small>
          <small class="" v-else-if="$v.address_google.plzValidate === false && !address_missingNo">Für diese Hausnummer wurde keine Adresse gefunden.</small>
        </template>
      </div>
    </div>

    <div class="row d-none">
      <div class="col-4">
        <div class="rueden-input">
          <input ref="address_plz" class="form-control" type="text" v-model="data.plz" name="plz" :required="required"/>
        </div>
      </div>
      <div class="col-4">
        <div class="rueden-input">
          <input class="form-control" type="text" v-model="data.ort" name="ort" :required="required"/>
        </div>
      </div>
      <div class="col-4">
        <div class="rueden-input">
          <input ref="land" class="form-control" type="text" v-model="data.land" name="land" :required="required"/>
        </div>
      </div>
    </div>

    <div v-if="address_missingNo" class="col-12 col-md-3">
      <div class="rueden-input">
        <label>{{ numberLabel }}</label>
        <input ref="streetNumber" @change="setStreetNumber()" class="form-control" type="text" v-model="strasse_nummer" :class="{'border-danger' : $v.strasse_nummer.$error}" name="strasse_nummer" :required="required"/>
      </div>
    </div>
  </div>
</template>
<script>
import General from '@/mixins/general';

import VueGoogleAutocomplete from 'vue-google-autocomplete';
import {required, helpers} from 'vuelidate/lib/validators'

const isSet = (param) =>
    function () {
      return param.plz != null
    }
const startsWithDigit = helpers.regex('startsWithDigit', /^\d/);

export default {
  mixins: [General],
  components: {VueGoogleAutocomplete},
  props: {
    value: Object,
    gaCat: String,
    required: {
      type: Boolean,
      default: false
    },
    tooltip: String,
    countries: {
      default: ['de','ch','at']
    }
  },
  data() {
    return {
      address_google: null,
      strasse_nummer: null,
      address_missingNo: false,
      numberLabel: 'Nr.',
      addressLabel: 'Straße, Ort',
      data: this.value
    }
  },
  mounted() {
    if (this.data.strasse) {
      let sParts = this.data.strasse.split(" ");
      this.address_missingNo = !(
          (sParts.length > 1 && /\d/.test(sParts[sParts.length - 1]))
          || (sParts.length > 2 && /\d/.test(sParts[sParts.length - 2]))
      );
    }
    if (this.$v.address_google.$invalid) {
      this.changeErrorCount(true);
      // console.log("+1", "Google Adresse erstellt");
    }
    this.setGoogleAddress();
  },
  destroyed() {
    if (this.$v.address_google.$invalid) {
      this.changeErrorCount(false);
      // console.log("-1", "Google Adresse destroyed");
    }
    if (this.address_missingNo && this.$v.strasse_nummer.$invalid) {
      this.changeErrorCount(false);
      // console.log("-1", "Haus Nummer destroyed");
    }
  },
  validations() {
    let rules = {};
    if (this.required) {
      rules.address_google = {...rules.address_google, ...{ required, plzValidate: isSet(this.data) }};
      rules.strasse_nummer = {...rules.strasse_nummer, ...{ required, startsWithDigit }};
    }
    return rules;
  },
  watch: {
    address_google: function () {
      this.$v.address_google.$touch();
    },
    strasse_nummer: function () {
      this.$v.strasse_nummer.$touch();
    },
    $global: function (newV) {
      if (newV.showAllInputError) {
        this.$v.address_google.$touch();
        if (this.address_missingNo) {
          this.$v.strasse_nummer.$touch();
        }
      }
    },
    '$v.address_google.$invalid': function (newV) {
      this.changeErrorCount(newV);
      // console.log(newV ? "+1" : "-1", "Google Adresse verändert");
    },
    '$v.strasse_nummer.$invalid': function (newV) {
      if (this.address_missingNo) {
        this.changeErrorCount(newV);
        // console.log(newV ? "+1" : "-1", "Haus Nummer verändert");
      }
    },
    address_missingNo: function (newV) {
      if (newV && this.$v.strasse_nummer.$invalid) {
        this.changeErrorCount(true);
        // console.log("+1","Haus Nummer eingeblendet (flasch)");
      } else if (!newV && this.$v.strasse_nummer.$invalid) {
        this.changeErrorCount(true);
        // console.log("+1","Haus Nummer ausgeblendet (flasch)");
      }
    }
  },
  methods: {
    getAddressData: function (addressData) {
      this.data.land = addressData.country;
      this.data.ort = addressData.locality;
      if (addressData.postal_code) {
        this.data.plz = addressData.postal_code;
      } else {
        this.data.plz = null;
      }
      if (addressData.street_number) {
        this.strasse_nummer = addressData.street_number;
        this.data.strasse = addressData.route  + ' ' + this.strasse_nummer;
        this.address_missingNo = false;
        this.sendGaEvent(this.gaCat, this.addressLabel+" und "+this.numberLabel);
      } else {
        this.strasse_nummer = null;
        this.data.strasse = addressData.route;
        setTimeout(() => {
          this.$refs.streetNumber.focus();
        });
        this.address_missingNo = true;
        this.sendGaEvent(this.gaCat,this.addressLabel);
      }
      this.setGoogleAddress();
    },
    setGoogleAddress() {
      let prevAddress = '';
      if (this.data.strasse) prevAddress = this.data.strasse;
      if (this.data.ort) {
        if (this.data.plz) {
          prevAddress = prevAddress + ", " + this.data.plz + " " + this.data.ort;
        } else {
          prevAddress = prevAddress + ", " + this.data.ort;
        }
      }
      if (this.data.land) prevAddress = prevAddress + ", " + this.data.land;
      if (prevAddress) {
        this.address_google = prevAddress;
        this.$refs.addressGoogle.$el.value = this.address_google;
      }
      this.$emit('input', this.data);
    },
    blurGetAddressData() {
      if (
          !this.data.strasse
          || !this.data.ort
      ) {
        this.$refs.addressGoogle.$el.value = "";
      } else {
        this.setGoogleAddress();
      }
    },
    setStreetNumber() {
      if (this.strasse_nummer) {
        this.$emit('input', this.data);
        this.sendGaEvent(this.gaCat, this.numberLabel);
        this.data.strasse = this.data.strasse + ' ' + this.strasse_nummer;
        this.setGoogleAddress();
        this.address_missingNo = false;
        if (!this.data.plz && this.data.strasse && this.data.ort && this.data.land) {
          var _this = this;
          var service = new window.google.maps.places.AutocompleteService();
          service.getPlacePredictions({ input: this.address_google, types: ['address'] }, function(predictions){
            var pID = predictions[0].place_id;
            var service2 = new window.google.maps.places.PlacesService(document.createElement('address_google'));
            service2.getDetails({fields:['address_components'], placeId:pID}, function(r) {
              r.address_components.forEach(function(c) {
                if (c.types.includes('postal_code')) {
                  _this.data.plz = c.long_name;
                  _this.setGoogleAddress();
                }
              });
            });
          });
        }
      }
    },
  }
}
</script>
